import * as events from 'events';

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Domain as WebsideDomain } from "../../../lib/Domain/Webside"
@Injectable()
export class AccountService extends events.EventEmitter {
  //\lib\Server\Webside\route\api\userRoute.ts
  constructor(private http: Http) { super(); }
  public async Update(user: WebsideDomain.IAccount): Promise<WebsideDomain.IAccount> {
    const result = await this.http.post('/api/user/update', user)
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status == WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IAccount;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async Delete(user: WebsideDomain.IAccount): Promise<string> {
    const result = await this.http.post('/api/user/delete', user)
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status == WebsideDomain.ResultCode.FTK_OK) {
      return result.data;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async List(): Promise<WebsideDomain.IAccount[]> {
    const result = await this.http.get('/api/user/list')
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status == WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IAccount[];
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async Info(email: string): Promise<WebsideDomain.IAccount> {
    return undefined;
  }
  public async Loginstat(): Promise<any> {
    const result = await this.http.get('/api/user/loginstat')
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch()
    if (result && result.status == WebsideDomain.ResultCode.FTK_OK) {
      return result.data;
    } else {
      throw new Error(`登入失敗 ${result.message}`);
    }
  }
  public async Login(email: string, password: string, rememberMe: boolean): Promise<WebsideDomain.IAccount> {
    const result = await this.http.post('/api/user/login', { email, password, rememberMe })
      .toPromise()
      .then(response => response.json())
      .catch()
    if (result && result.status == WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IAccount;
    } else {
      throw new Error(`登入失敗 ${result.message}`);
    }
  }
  public async Logout(): Promise<void> {
    await this.http.get('/api/user/logout')
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch()
  }
  public async ChangePassword(oldPassword: string, newPassword: string): Promise<void> {
    const result = await this.http.post('/api/user/changepass', <WebsideDomain.IChangePasswordRequest>{ oldPassword, newPassword })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch()
    if (result && result.status == WebsideDomain.ResultCode.FTK_OK) {
      return;
    } else {
      throw new Error(`${result.message}`);
    }
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account.service.ts